var React = require('react');

function SocialYoutube (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M31.29,8.51c-.18-.68-.54-1.3-1.04-1.79-.5-.5-1.12-.85-1.79-1.04-2.48-.68-12.48-.68-12.48-.68,0,0-9.99,.02-12.48,.7-.68,.18-1.3,.54-1.79,1.04-.5,.5-.85,1.12-1.04,1.79-.75,4.41-1.04,11.14,.02,15.37,.18,.68,.54,1.3,1.04,1.79,.5,.5,1.12,.85,1.79,1.04,2.48,.68,12.48,.68,12.48,.68,0,0,9.99,0,12.48-.68,.68-.18,1.3-.54,1.79-1.04,.5-.5,.85-1.12,1.04-1.79,.79-4.42,1.04-11.14-.02-15.39Z","fill":"red","key":0}),React.createElement("path",{"d":"M12.8,21.01l8.29-4.8-8.29-4.8v9.6Z","fill":"#fff","key":1})]);
}

SocialYoutube.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = SocialYoutube;

SocialYoutube.default = SocialYoutube;
